"use client";
import { Card } from "@/components/card";
import { cn } from "@/lib/utils";
import { Swiper, SwiperSlide } from "swiper/react";

export function ContentSkeleton() {
  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="col-span-8 xl:col-span-2 m-auto px-4 pb-8 container">
        <span className="block bg-[#DED7CA] mb-1 lg:mb-4 rounded-2xl w-full lg:w-6/12 h-4 lg:h-7 animate-pulse" />
        <span className="lg:hidden block bg-[#DED7CA] mb-4 rounded-2xl w-8/12 lg:w-6/12 h-4 lg:h-7 animate-pulse" />

        <span className="justify-stretch gap-2 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8">
          {Array.from({ length: 16 }, (_, index) => (
            <span
              key={index}
              className="bg-[#DED7CA] rounded-2xl w-full h-30 lg:h-26 aspect-square lg:aspect-auto animate-pulse"
            />
          ))}
        </span>
      </div>

      <div className="order-2 col-span-4">
        {Array.from({ length: 2 }, (_, index) => {
          const isEven = index % 2 === 0;

          return (
            <div
              key={index}
              className={cn("py-4", { "bg-[#DED7CA60]": isEven })}
            >
              <div className="flex flex-col justify-center gap-4 m-auto px-4 container">
                <div>
                  <span className="block bg-[#DED7CA] mb-1 rounded-2xl w-full lg:w-6/12 h-4 lg:h-7 animate-pulse" />
                  <span className="lg:hidden block bg-[#DED7CA] mb-4 rounded-2xl w-8/12 lg:w-6/12 h-4 lg:h-7 animate-pulse" />
                </div>

                <div className="relative">
                  <Swiper
                    navigation
                    pagination={{ clickable: true }}
                    spaceBetween={8}
                    breakpoints={{
                      480: { slidesPerView: 1.1 },
                      640: { slidesPerView: 2.1 },
                      768: { slidesPerView: 2.1 },
                      1024: { slidesPerView: 3.1 },
                      1280: { slidesPerView: 4.1 },
                    }}
                    className="!pb-8"
                  >
                    {Array.from({ length: 5 }, (_, index) => (
                      <SwiperSlide key={index}>
                        <Card className="bg-[#DED7CA] h-48 xl:h-60 animate-pulse">
                          <span />
                        </Card>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
